export const API_BASE = window.wwoofBooking?.apiUrl || '/wp-json/booking-system/v1/';

export const ENDPOINTS = {
  BOOKINGS_CREATE: 'bookings/create',
  BOOKINGS_WWOOFER_CREATE: 'bookings/wwoofer-create',
  BOOKINGS_USER: (userId) => `bookings/user/${userId}`,
  BOOKING_ACCEPT: (id) => `bookings/${id}/accept`,
  BOOKING_CANCEL: (id) => `bookings/${id}/cancel`,
  BOOKING_EDIT_DATES: (id) => `bookings/${id}/edit-dates`,

  // Review endpoints
  REVIEWS_FORM: 'reviews/form',
  REVIEWS_SUBMIT: 'reviews/submit',
  REVIEWS_LIST: 'reviews/list',
  REVIEWS_RESPOND: 'reviews/respond',
  REVIEWS_STATS: 'reviews/stats',
  REVIEW_DETAIL: (id) => `reviews/${id}`,
};
